import moment from "moment";
import { IconButton } from "../../components/shared/icons";
import { dateFormat } from "../../components/shared/constants";

export const ExcludedDatesButton = ({ RateExcludedDates = [], onClick }) => {
    const now = moment().startOf('day');
    const filteredDates = RateExcludedDates.filter(ed => {
        const endDate = moment(ed.EndDate).endOf('day');
        return endDate.isSameOrAfter(now);
    });

    const excludedDatesMessage = (excludedDates = []) => {
        return excludedDates.map(ed => ({
            startDate: moment(ed.StartDate),
            endDate: moment(ed.EndDate)
        })).sort((a, b) => a.endDate.isSameOrBefore(b.endDate) ? -1 : 1)
            .map(ed => {
                const start = ed.startDate.format(dateFormat);
                const end = ed.endDate.format(dateFormat);
                return `${start} - ${end}`;
            }).join('\n');
    }

    const excludedDatesButtonStyles = {
        border: filteredDates.length ? 'solid 1px red' : undefined
    }

    const excludedDatesPopupStyles = {
        style: {
            maxWidth: '200px',
            whiteSpace: 'pre-wrap',
            textAlign: 'left',
        },
        position: 'top left'
    }
    return <IconButton
        floated="right"
        popupProps={excludedDatesPopupStyles}
        style={excludedDatesButtonStyles}
        icon="calendar"
        basic
        content="ExcludedDates"
        literalContent={filteredDates.length && excludedDatesMessage(filteredDates)}
        resetStyles={false}
        onClick={onClick}
    />
}
